import React from 'react'
import { Typography } from '@mui/material'
import { getGridNumericOperators } from '@mui/x-data-grid-pro'
import { TopicRowModel } from '@features/topics/provider/TopicsProvider'
import { useTranslation } from 'react-i18next'
import { FILTER_OPERATOR_LABELS, RELEVANT_NUMBER_OPERATORS } from '@shared/constants/dataGrid'

import { TopicsColumnType } from '../topicsDataGridColumns'

const RenderCell: React.FC<{row: TopicRowModel}> = ({ row }) => {
  const { t } = useTranslation()

  return (
    <Typography
      variant="subtitle1"
      fontWeight={500}
    >{t('common.trainingYearWithNumber', { year: row.trainingYear })}</Typography>
  )
}

export const trainingYearColumnModel: TopicsColumnType = {
  field: 'trainingYear',
  width: 125,
  filterOperators: getGridNumericOperators().filter((operator) =>
    Object.keys(RELEVANT_NUMBER_OPERATORS).includes(operator.value)).map((operator) => ({
    ...operator,
    type: 'number',
    label: FILTER_OPERATOR_LABELS[operator.value as keyof typeof FILTER_OPERATOR_LABELS]
  })),
  type: 'number',
  align: 'left',
  headerAlign: 'left',
  valueGetter (params) {
    return params.row.trainingYear
  },
  renderCell: (params) => <RenderCell row={params.row} />
}
